<div id="ht">
    <div id="main-cnt">


        <ion-header>
            <ion-toolbar class="blues-nav">
                <ion-row>
                    <ion-col size="2" class="nav-back">
        <span class="custom-icon-back-arrow-icon" (click)="back()">
          <span class="path1"></span> <span class="path2"></span> </span>
                    </ion-col>
                    <ion-col size="10" class="nav-content">
                        <ion-title>
                            <span>TRC20</span>
                        </ion-title>
                    </ion-col>
                </ion-row>
            </ion-toolbar>

            <div class="">
                <form class="filter-cnt">
                    <ion-row class="filter-row">
                        <ion-col size="12">
                            <input [(ngModel)]="filters.name" name="name" class="search-input"
                                   placeholder="Ricerca per nome" type="search" (keyup)="filterUsers()">
                        </ion-col>
                    </ion-row>
                </form>
            </div>

        </ion-header>

        <ion-content>
            <div class="">
                <div class="">
                    <p class="no-results" *ngIf="!userList?.length">No client found</p>

                    <div class="" *ngFor="let user of userList; let i=index;">
                        <ion-list class="invoice-list">
                            <ion-item-sliding>
                                <ion-item class="slide-item glass-blurred-background">
                                    <div class="invoice-content">
                                        <ion-row>
                                           <!-- <ion-col size="2">
                                                <div class="user-icon-small">
                                                    <img *ngIf="user.profileImg"
                                                         class="space-below  list-avatar"
                                                         [src]="user.profileImg |s3Link"
                                                    />
                                                    <img  *ngIf="!user?.profileImg" src="https://thumbs.dreamstime.com/b/default-avatar-profile-vector-user-profile-default-avatar-profile-vector-user-profile-profile-179376714.jpg">
                                                </div>
                                            </ion-col>-->
                                            <ion-col size="10">
                                                <ion-row style="white-space: nowrap;">
                                                    <div class="id">{{ user.name |titlecase}} {{ user.lastname |titlecase}}</div>
                                                </ion-row>
                                                <div class="">{{ user.TRC20 }}</div>
                                            </ion-col>
                                            <ion-col size="2" class="ion-align-items-center vertical-middle" >
                                                <div class="doc-icon copy heigt-100" (click)="copy(user.TRC20)"></div>
                                            </ion-col>
                                        </ion-row>
                                    </div>
                                </ion-item>
                            </ion-item-sliding>
                        </ion-list>
                    </div>
                </div>
            </div>
        </ion-content>
    </div>
</div>
